// extracted by mini-css-extract-plugin
export var lightBg = "styles-module--lightBg--WbeL3";
export var row = "styles-module--row--Gv7JB";
export var blogPostRow = "styles-module--blogPostRow--Mjibw";
export var quote = "styles-module--quote--RLlKR";
export var textRight = "styles-module--textRight--3TTPm";
export var mainCta = "styles-module--mainCta--N1NtY";